// test1586
(1586 && 0);
